import { toast } from 'react-toastify';
import { DURATION, NOTIFICATION } from 'common/constants';

export default ({
  type,
  title,
  autoClose = DURATION.LONG,
  closeButton = true,
  closeOnClick = true,
  hideProgressBar = true,
  position = toast.POSITION.BOTTOM_LEFT,
}) => {
  let containerId = NOTIFICATION.VARIANTS.DEFAULT;
  const isPassWordExpiryError =
    typeof title === 'string' && title?.toLowerCase()?.includes('your password has expired');
  if (isPassWordExpiryError) {
    containerId = NOTIFICATION.VARIANTS.PASSWORD_EXPIRY;
  }
  return toast(title, {
    ...(typeof title === 'string' && { toastId: title }),
    type,
    autoClose,
    closeButton,
    closeOnClick,
    containerId,
    hideProgressBar,
    position,
    ...(position === toast.POSITION.BOTTOM_LEFT && { className: 'custom-toast-position' }),
  });
};
